import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { storeRegistry } from '@/store/storeRegistry'

export interface ErrorEntry {
  id: string
  httpStatusCode: number
  requestUrl: string
  httpMethod: string
  errorMessage: string
  responseBody: unknown
  capturedAt: string
  apiDiagnostics?: ApiDiagnostics
}

export interface ApiDiagnostics {
  statusCode?: number
  timestamp?: string
  startTime?: string
  endTime?: string
  duration?: string
}

export const MAX_ERROR_ENTRIES = 100

export const useErrorStore = defineStore('errorStore', () => {
  const errors = ref<ErrorEntry[]>([])
  const unreadCount = ref(0)

  const errorCount = computed(() => errors.value.length)

  function pushError(entry: ErrorEntry): void {
    errors.value.unshift(entry)
    unreadCount.value++
    if (errors.value.length > MAX_ERROR_ENTRIES) {
      errors.value.pop()
    }
  }

  function dismissError(id: string): void {
    errors.value = errors.value.filter((e) => e.id !== id)
  }

  function clearAll(): void {
    errors.value = []
    unreadCount.value = 0
  }

  function resetUnreadCount(): void {
    unreadCount.value = 0
  }

  function resetStore(): void {
    errors.value = []
    unreadCount.value = 0
  }

  storeRegistry.register('errorStore', resetStore)

  return {
    errors,
    unreadCount,
    errorCount,
    pushError,
    dismissError,
    clearAll,
    resetUnreadCount,
    resetStore
  }
})
